import { useEffect } from 'react';

const DEFAULT_HEIGHT = '100px';

/* The --headerHeight custom CSS property is set here so that it can be
 * used by other parts of the Bynder system that are dependent on the
 * size of the header. For example, Brand Guidelines (at the time of
 * writing this comment) uses a hard-coded header height in its page
 * layout. */

export function useHeaderHeightCSSProperty() {
	useEffect(() => {
		const header = document.querySelector('header.base') as HTMLElement;

		document.documentElement.style.setProperty('--headerHeight', DEFAULT_HEIGHT);

		const resizeObserver = new ResizeObserver(() => {
			document.documentElement.style.setProperty(
				'--headerHeight',
				header.offsetHeight + 'px',
			);
		});

		resizeObserver.observe(header);

		return () => {
			resizeObserver.unobserve(header);
		};
	}, []);
}
